<template lang="pug">
div.px-8
  v-row(no-gutters)
    v-col.pr-8.shrink
      div.sticky.white(style="width: 150px; top: 106px;")
        .text-md.font-semibold.neutral500--text.px-6.py-2.round-md.mb-2.clickable(@click="$router.push('/admin/clinic/inventory')") Inventory
        .text-md.font-semibold.neutral500--text.px-6.py-2.round-md.mb-2.clickable(@click="$router.push('/admin/clinic/services')") Services
        .text-md.font-semibold.neutral500--text.px-6.py-2.round-md.mb-2.clickable(@click="$router.push('/admin/clinic/packages')") Packages
        .text-md.font-semibold.neutral500--text.px-6.py-2.round-md.mb-2.clickable(@click="$router.push('/admin/clinic/stocktakes')") Stock take
        .text-md.font-semibold.neutral500--text.px-6.py-2.round-md.mb-2.clickable(v-if="company.is_hq || company.branch_of" @click="$router.push('/admin/clinic/branches-warehouses')") Branches & Warehouses
        .text-md.font-semibold.neutral200.px-6.py-2.round-md.mb-2 Locations
        .text-md.font-semibold.neutral500--text.px-6.py-2.round-md.mb-2.clickable(v-if="Auth('root', 'subscribe_purchase_hub')" @click="$router.push('/admin/clinic/inventory-list')") List

    v-col.grow
      v-container.py-8(fluid)
        v-row.mb-2(no-gutters align="center")
          v-col.shrink
            v-btn.ml-n3(text icon @click="goBack" height)
              v-icon(color="neutral700" :size="24") mdi-arrow-left
          v-col.ml-3
            .text-2xl.font-semibold.neutral700--text Locations
        .d-flex.align-center
          v-spacer
          v-btn(@click="clickSearch" icon color="neutral500")
            v-icon(size="20") $yzi-search-sm
          v-text-field(v-if="showSearchField" v-model="searchText" @blur="blurSearch" @input="queryChanged" solo dense flat placeholder="Type to search..." hide-details clearable autofocus)
          div
            customize-column-menu(type="location" :showTooltip="false" iconSize="21")
          y-button.ml-3(label="Create new location" size="sm" @click="addNewLocation")
        v-divider.mt-2

        filter-locations-row.my-2(:filters.sync="filters" ref="filter")
        .data-table
          v-data-table.mt-sm-4.pb-6(:headers="headers" :items="locations" item-key="id" :items-per-page="pageSize" hide-default-footer :loading="isFetching" :disable-sort="isMobileScreen" :header-props="{ sortIcon: '$yzi-triangle' }" @click:row="editLocation")
            //- name
            template(v-slot:item.name="{ item }")
              .text-sm.neutral700--text {{ item.value }}
            //- created
            template(v-slot:item.created="{ item }")
              .text-sm.neutral700--text {{ item.created | humanizeDate }}
            //- inventory
            template(v-slot:item.inventory="{ item }")
              .text-sm.neutral700--text(v-if="item.products.length") {{ item.products.length }}
              .text-sm.neutral700--text(v-else) -
            //- actions
            template(v-slot:item.actions="{ item, index }")
              div(@click.stop)
                v-menu(offset-y :top="menuPositionTop(index)" left attach rounded="lg")
                  template(#activator="{ on }")
                    v-btn(icon small v-on="on")
                      v-icon mdi-dots-horizontal
                  v-list.py-0
                    v-list-item(@click="editLocation(item)")
                      v-list-item-title.text-sm.basic800--text Edit item
                    v-divider
                    v-list-item(@click="deleteLocation(item)")
                      v-list-item-title.text-sm.danger500--text Delete item

        div.d-flex.align-center(v-if="totalCount > pageSize")
          v-spacer
          yc-pagination-custom(v-model="currentPage" :parentPageSize.sync="pageSize" :count="totalCount" attach menu-top @input="pageChanged")

  .dialogs
    delete-confirmation-dialog(v-if="openDeleteDialog" :open.sync="openDeleteDialog" :loading="isLoading" @cancel="closed" @delete="confirmDelete")
      .text-lg.font-medium Are you sure you want to delete this location?
      .text-md.mt-4 This action will be done immediately and can’t be undone. Click “Confirm” to proceed

</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'
import { debounce } from '@/utils'
import CustomizeColumnMenu from '@/components/connect/CustomizeColumnMenu.vue'
import DeleteConfirmationDialog from '@/components/clinic/dialogs/DeleteConfirmationDialog.vue'
import FilterLocationsRow from '@/components/clinic/inventory/FilterLocationsRow.vue'

export default {
  name: 'Locations',
  components: { CustomizeColumnMenu, DeleteConfirmationDialog, FilterLocationsRow },
  props: ['prevPage'],
  data: () => ({
    isFetching: false,
    isLoading: false,
    showSearchField: false,
    openDeleteDialog: false,
    searchText: null,
    selectedLocation: null,
    pageSize: 20,
    totalCount: 0,
    currentPage: 1,
    locations: [],
    filters: [],
  }),
  computed: {
    ...mapState('user', ['user']),
    ...mapGetters({
      company: 'getCompany',
      locationFields: 'clinic/getLocationFields'
    }),
    isMobileScreen () {
      return this.$vuetify.breakpoint.xs
    },
    headers () {
      const name = { text: 'Name', value: 'name', enable: true }
      const fields = this.locationFields.filter(item => item.enable)
      fields.map(item => {
        item.text = item.field_name
        item.value = item.id
      })
      const actions = {
        text: '',
        value: 'actions',
        enable: true,
        sortable: false,
        width: 60
      }
      return [name, ...fields, actions]
    },
  },
  watch: {
    pageSize () {
      this.currentPage = 1
      this.fetchLocations()
    },
    filters () {
      this.currentPage = 1
      this.fetchLocations()
    },
  },
  mounted () {
    if (this.prevPage) {
      this.currentPage = this.prevPage
    }
    this.headers.map(item => item['class'] = 'text-table-header')
    this.fetchLocations()
  },
  methods: {
    ...mapActions(['showMessage']),
    fetchLocations () {
      this.isFetching = true
      const params = {
        page_size: this.pageSize,
        page: this.currentPage,
        ordering: 'value'
      }
      if (this.searchText) { params.search = this.searchText }
      this.filters.forEach(filter => {
        params[filter.key] = filter.value
      })
      this.$axios.get(`/clinics/${this.company.slug}/inventories/locations`, { params })
        .then(resp => {
          this.locations = resp.data.results
          this.totalCount = resp.data.count
        })
        .catch(() => {})
        .finally(() => {
          this.isFetching = false
        })
    },
    clickSearch () {
      if (this.showSearchField) {
        if (!this.searchText || this.searchText.length === 0) {
          this.showSearchField = false
        }
      } else {
        this.showSearchField = true 
      }
    },
    blurSearch () {
      if (!this.searchText || this.searchText.length === 0) {
        this.showSearchField = false
      }
    },
    queryChanged: debounce(function () {
      this.currentPage = 1
      this.fetchLocations()
    }, 750),
    pageChanged () {
      this.fetchLocations()
    },
    addNewLocation () {
      this.$router.push('/admin/clinic/location')
    },
    editLocation (item) {
      let params = { id: item.id }
      if (!this.filters.length) {
        params.page = this.currentPage
      }
      this.$router.push({ name: 'EditClinicInventoryLocation', params })
    },
    goBack () {
      this.$router.push('/admin/clinic/settings')
    },
    confirmDelete () {
      this.isLoading = true
      this.$axios.delete(`/clinics/${this.company.slug}/inventories/locations/${this.selectedLocation.id}`)
        .then(() => {
          this.currentPage = 1
          this.reset()
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    deleteLocation (item) {
      this.selectedLocation = item
      this.openDeleteDialog = true
    },
    reset () {
      this.fetchLocations()
      this.closed()
    },
    closed () {
      this.selectedLocation = null
      this.openDeleteDialog = false
    },
    menuPositionTop (index) {
      let position = index + 1
      if (position > 7) {
        let start = this.locations.length - 3
        if (position > start) {
          return true
        }
      }
      return false
    },
  }
}
</script>

<style scoped>
.column-width {
  width: 200px;
}
::v-deep .v-data-table__wrapper table tbody tr:hover{
  cursor: pointer;
  background: var(--v-neutral200) !important; 
}
</style>